import { render, staticRenderFns } from "./manyChart.vue?vue&type=template&id=2b8f810e&scoped=true&"
import script from "./manyChart.vue?vue&type=script&lang=js&"
export * from "./manyChart.vue?vue&type=script&lang=js&"
import style0 from "./manyChart.vue?vue&type=style&index=0&id=2b8f810e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f810e",
  null
  
)

export default component.exports